import React, { useState } from 'react';
import { QuotesAndOrdersHeader } from './Header';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RecordsTable } from 'dyl-components';
import QuotesAndOrdersRow from './Row';
import QuoteBuilderModal from 'shared/modals/QuoteBuilderModal';

const QuotesAndOrdersTable = ({ isColumnHidden, onPageChange, onCallIconClick }) => {
    const { count, quotesAndOrders, isReadingQuotesAndOrders } = useSelector(state => ({
        count: state.quotes_and_orders.count,
        quotesAndOrders: state.quotes_and_orders.entries,
        isReadingQuotesAndOrders: state.quotes_and_orders.isReadingQuotesAndOrders
    }));

    const [params] = useSearchParams();

    const [entryBeingViewed, setEntryBeingViewed] = useState(null);

    const { account, contact, opportunity } = quotesAndOrders.find(entry => entry.id === entryBeingViewed) || { account: {}, contact: {}, opportunity: {} };

    const onClose = () => {
        setEntryBeingViewed(null);
    }

    const onView = (id) => {
        setEntryBeingViewed(id);
    }

    return (
        <>
            <RecordsTable
                tableBodyClassName='QuotesAndOrdersTable'
                isTableLoading={isReadingQuotesAndOrders}
                isSearchResultEmpty={count === 0 && (params.get('start') || params.get('end'))}
                isTableEmpty={count === 0 && !(params.get('start') || params.get('end'))}
                TableHeader={<QuotesAndOrdersHeader isColumnHidden={isColumnHidden} />}
                TableRows={quotesAndOrders.map(log => (
                    <QuotesAndOrdersRow onView={onView} key={log.id} entry={log} isColumnHidden={isColumnHidden} onCallIconClick={onCallIconClick}/>
                ))}
                recordsCount={count}
                activePage={params.get('page')}
                onPageChange={onPageChange}
                recordsName='Quotes or Orders'
                emptySubtitle=' '
                emptyListTitle='No Quotes or Orders Created'
            />
            <QuoteBuilderModal
                account_id={account?.id}
                contact_id={contact?.id}
                opportunity_id={opportunity?.id}
                account_primary_contact_id={account?.primary_contact_id}
                isLinkedToCustomer={account?.customer}
                onClose={onClose}
            />
        </>
    )
}

export default QuotesAndOrdersTable;
